import { keyframes, styled } from 'styled-components'

const loading = keyframes`
  50% {
    transform: scale(10);
  }
  100% {
    transform: scale(1);
  }
`

export const Loading = styled.div`
    background:linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%);
    border-radius:50%;
    width:10px;
    height:10px;
    animation: ${loading} 1s linear infinite;
    position: absolute;
    top:50%;
    left:50%;

`; 
